import React from "react";

import classes from "./styles.module.scss";
import { Button, ModalBody } from "Components/ReactstrapSlim";
import CloseButton from "../../CloseButton";
import List from "../../List";
import classNames from "classnames";

interface ModalBodyListProps {
   toggle(): void;
}

const ModalBodyBook: React.FC<ModalBodyListProps> = ({ toggle }) => {
   const showSupportChat = () => {
      toggle();
      LSHelper.HelperLib.openSupportChat();
   }

   return <ModalBody className={classes.modalBody}>
      <CloseButton toggle={toggle} />
      <div className={classes.header}>
         Join the largest flexible office marketplace.
      </div>
      <List
         className={classes.list}
         items={[
            {
               title: "Build your profile:",
               description: "Create a profile online, add space details, then set prices and availability."
            },
            {
               title: "Publish your listings:",
               description: "Validate your listings on LiquidSpace Marketplace."
            },
            {
               title: "Manage bookings:",
               description: "Effortlessly control communications and calendars through your venue manager portal."
            }
         ]}
      />
      <div className={classes.buttons}>
         <a className={classNames("btn btn-primary btn-lg", classes.cta)} href="/share-office-meeting-space">List Space Now</a>
         <Button color="link" className={classes.btnSupport} size="lg" onClick={showSupportChat}>Contact Support</Button>
      </div>
   </ModalBody>
}

export default ModalBodyBook;